import { data } from '../../svg/Notifications/data';
import { makeIcon } from '../makeIcon';

export const Notifications = makeIcon(data, 'notifications', 'Notifications');

export default Notifications;
